import { Option } from "../../../components/options/types";
import { ObjectId } from "../../../types";

export const TOP_TAGS: Array<Option<ObjectId>> = [
  {
    title: "همه",
    value: { $oid: "517" },
  },
  {
    title: "شرکت ها",
    value: { $oid: "519" },
  },
  {
    title: "خریداران",
    value: { $oid: "512" },
  },
  {
    title: "فروشندگان",
    value: { $oid: "515" },
  },
];
